import { FULL_API_BASE_URL } from "../Config/Config";

const EndPoints = {
  TopicsByChapterList: `${FULL_API_BASE_URL}/get-topics-by-chapter-list/`,
  DppQuestionPaper: `${FULL_API_BASE_URL}/get-dpp-question-paper/`,
  CreateDppSchedule: `${FULL_API_BASE_URL}/create-dpp-schedule/`,
  GetCourses: `${FULL_API_BASE_URL}/get-courses/`,
  GetSubjectsByCourse: `${FULL_API_BASE_URL}/get-subjects-by-course/`,
  GetChaptersBySubject: `${FULL_API_BASE_URL}/get-chapters-by-subject/`,
  GetBatchByCourse: `${FULL_API_BASE_URL}/get-batch-name-by-course-id/`,
  GetClasses: `${FULL_API_BASE_URL}/get-classes/`,
  GetDPPScheduleDetails: `${FULL_API_BASE_URL}/get-dpp-schedule-details-by-dpp-schedule-id/`,
  GetQuestionPaperList: `${FULL_API_BASE_URL}/get-ques-paper-list/`,
  GetInstructionTemplateList: `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/`,
  PutUpdateDppSchedule: `${FULL_API_BASE_URL}/update-dpp-schedule/`,
  PutCancelDppSchedule: `${FULL_API_BASE_URL}/cancel-dpp-schedule/`,
  GetStudentProfileDetails: `${FULL_API_BASE_URL}/get-student-profile-details/`,
  GetStudentProgressCard: `${FULL_API_BASE_URL}/get-rpt-student-progress-card/`,
  GetStudentNotes: `${FULL_API_BASE_URL}/get-student-notes/`,
  GetStudentAttendance: `${FULL_API_BASE_URL}/get-student-attendance/`,
  GetTestNamebyBatch: `${FULL_API_BASE_URL}/get-test-detail-by-batch-id/`,
  PostTestMarksCorrectionv3: `${FULL_API_BASE_URL}/test-marks-correction-v3/`,
  GetTestSummarybyBatch: `${FULL_API_BASE_URL}/get-test-summary-from-batch-id/`,
  GetQuestionsfromSetName: `${FULL_API_BASE_URL}/get-questions-by-set-name/`,
  CancelDppSchedule: `${FULL_API_BASE_URL}/cancel-dpp-schedule/`,
  GetTestSchedulebyId: `${FULL_API_BASE_URL}/get-test-schedule-details-by-test-schedule-id/`,
  GetTestSchedulebyIdv1: `${FULL_API_BASE_URL}/get-test-schedule-details-by-test-schedule-id-v1/`,
  PostGenerateTestCode: `${FULL_API_BASE_URL}/generate-test-code/`,
  AddStudentNote: `${FULL_API_BASE_URL}/add-student-notes/`,
  PaperDetailsReview: `${FULL_API_BASE_URL}/get-ques-paper-details-for-review/`,
  CreateQuestionPaperReviewHistory: `${FULL_API_BASE_URL}/create-question-paper-review-history/`,
  GetEmployeeBySearchKey: `${FULL_API_BASE_URL}/get-employee-by-search-key/`,
  GetRoles: `${FULL_API_BASE_URL}/get-roles/`,
  PatchDeactivateUser: `${FULL_API_BASE_URL}/deactivate-user/`,
  GetUsersDashboardDetails: `${FULL_API_BASE_URL}/get-users-dashboard-details/`,
  GetRolesByUserID: `${FULL_API_BASE_URL}/get-roles-by-user-id/`,
  ActivateDeactivateUser: `${FULL_API_BASE_URL}/activate-deactivate-user/`,
  UpdateUser: `${FULL_API_BASE_URL}/update-user/`,
  GetAllUserGroups: `${FULL_API_BASE_URL}/get-all-user-groups/`,
  GetUserGroupMembersById: `${FULL_API_BASE_URL}/get-user-group-members-by-id/`,
  GetEmployeeForGroup: `${FULL_API_BASE_URL}/search-emp-for-group/`,
  DeactivateUserGroup: `${FULL_API_BASE_URL}/deactivate-user-group/`,
  UpdateUserGroup: `${FULL_API_BASE_URL}/update-user-group/`,
  BranchList: `${FULL_API_BASE_URL}/get-branch-list/`,
  CreateUserGroup: `${FULL_API_BASE_URL}/create-user-group/`,
  LogOutUser: `${FULL_API_BASE_URL}/logout-web/`,
  TrackerOrTransactionAudit: `${FULL_API_BASE_URL}/create-transaction-audit/`,
  NotificationConfigurationDashboard: `${FULL_API_BASE_URL}/get-notification-dashboard-list/`,
  NotificationConfigByScreenId: `${FULL_API_BASE_URL}/get-notification-config-by-branch-id/`,
  GetCurrentDateTime: `${FULL_API_BASE_URL}/get-current-datetime`,
  UPDATE_NOTIFICATION_CONFIG_API: `${FULL_API_BASE_URL}/update-notification-config`,
  GET_USER_AND_GROUPS_SEARCH_KEY: `${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key`,
  CLIENT_LANDING_PAGE_INFO_V2: `${FULL_API_BASE_URL}/client-landing-page-info-web-v2`,
  CHECK_ROLL_NO: `${FULL_API_BASE_URL}/check_roll_no/`,
  NEW_STUDENT_REGISTRATION: `${FULL_API_BASE_URL}/new-student/`,
  GET_STUDENT_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-student-by-search-key/`,
  SEARCH_STUDENTS_WITHOUT_FEE_PLAN: `${FULL_API_BASE_URL}/search-students-without-fee-plan/`,
  GET_COURSE_FEES_FOR_STUDENT: `${FULL_API_BASE_URL}/get-course-fees-for-student/`,
  GENERATE_STUDENT_OTLC: `${FULL_API_BASE_URL}/generate-student-otlc/`,
  GENERATE_STUDENT_OTLC_V2: `${FULL_API_BASE_URL}/generate-student-otlc-v2/`,
  UPDATE_STUDENT_APP_ACCESS: `${FULL_API_BASE_URL}/update-student-app-access/`,
  STUDENT_REG_DASHBOARD: `${FULL_API_BASE_URL}/student_dashboard/`,
  CREATE_DPP_SCHEDULE_NOTIFICATION: `${FULL_API_BASE_URL}/create-dpp-schedule-notification/`,
  DPP_QUESTION_PAPER_V2: `${FULL_API_BASE_URL}/get-dpp-question-paper-v2/`,
  PDF_DOWNLOAD_TEST_SCHEDULE:`${FULL_API_BASE_URL}/generate-question-paper-pdf`,
  PDF_DOWNLOAD_DPP_SCHEDULE:`${FULL_API_BASE_URL}/generate-ques-paper-dpp-pdf`,
  STUDENT_DASHBOARD_V2: `${FULL_API_BASE_URL}/student-dashboard-v2`,
  STUDENT_DASHBOARD_FILTER_OPTIONS: `${FULL_API_BASE_URL}/student-dashboard-filter-options`,
  INCOMPLETE_DPP_REPORT: `${FULL_API_BASE_URL}/incomplete-dpp-report`,
  GET_STUDENT_SUMMARY_VIEW: `${FULL_API_BASE_URL}/get-student-summary-view/`,
  GetTestSeriesListByBranch: `${FULL_API_BASE_URL}/get-test-series-list-by-branch/`,
  CREATE_STUDENT_FEE_PLAN: `${FULL_API_BASE_URL}/create-student-fee-plan/`,
  CREATE_STUDENT_FEE_PAYMENT: `${FULL_API_BASE_URL}/create-student-fee-payment/`,
  GET_STUDENT_FEE_PLAN_DASHBOARD: `${FULL_API_BASE_URL}/get-student-fee-plan-dashboard/`,
  GET_STUDENT_FEE_PLAN: `${FULL_API_BASE_URL}/get-student-fee-plan/`,
  GET_SESSIONS_LIST: `${FULL_API_BASE_URL}/get-sessions-list`,
  GET_STUDENT_FEE_PAYMENT_HISTORY: `${FULL_API_BASE_URL}/get-student-fee-payment-history/`,
  UPDATE_STUDENT_FEE_PAYMENT_HISTORY: `${FULL_API_BASE_URL}/update-student-fee-payment-history/`,
  UPDATE_GROUPED_STUDENT_FEE_PAYMENT_HISTORY: `${FULL_API_BASE_URL}/update-grouped-student-fee-payment-history/`,
  GET_BATCH_TYPES: `${FULL_API_BASE_URL}/get-batch-types/`,
  GET_STUDENT_ADMISSION_PROFILE: `${FULL_API_BASE_URL}/get-student-admission-profile/`,
  GET_POST_DATED_CHEQUES: `${FULL_API_BASE_URL}/get-post-dated-cheques/`,
  CREATE_POST_DATED_CHEQUES: `${FULL_API_BASE_URL}/create-post-dated-cheques/`,
  UPDATE_POST_DATED_CHEQUES: `${FULL_API_BASE_URL}/update-post-dated-cheques/`,
  DELETE_POST_DATED_CHEQUE: `${FULL_API_BASE_URL}/delete-post-dated-cheque/`,
  GET_BANK_LIST: `${FULL_API_BASE_URL}/get-bank-list/`,
  UPDATE_STUDENT_FEE_PLAN: `${FULL_API_BASE_URL}/update-student-fee-plan/`,
  GET_STUDENT_FEE_PAYMENT_DASHBOARD: `${FULL_API_BASE_URL}/get-student-fee-payment-dashboard/`,
  GET_ENQUIRY_LIST: `${FULL_API_BASE_URL}/get-enquiry-list`,
  GET_PDCS_LIST:  `${FULL_API_BASE_URL}/get-list-of-pdcs/`,
  GET_PENDING_FEE_PLAN_LIST: `${FULL_API_BASE_URL}/get-pending-fee-plan-list/`,
  GET_CASHBOOK_LIST: `${FULL_API_BASE_URL}/get-cashbook-by-date-range/`,
};

export default EndPoints;